/**
 * The only place hardcoded hex is allowed: coin and exchange brand marks, where
 * the colour IS the identity and must not flip with the theme.
 * Ported verbatim from docs/design/newia-web/ms-atoms.jsx (SK.COIN / SK.BRAND).
 */
export const COIN: Record<string, string> = {
  BTC: "#F7931A",
  ETH: "#627EEA",
  SOL: "#14F195",
  USD: "#2775CA",
  USDC: "#2775CA",
  USDT: "#26A17B",
  LINK: "#2A5ADA",
  AVAX: "#E84142",
  MATIC: "#8247E5",
  ADA: "#0033AD",
  DOT: "#E6007A",
  XRP: "#23292F",
  DOGE: "#C2A633",
  BNB: "#F0B90B",
};

/** [background, glyph, glyph colour] */
export const BRAND: Record<string, [string, string, string]> = {
  coinbase: ["#0052FF", "C", "#fff"],
  binance: ["#F0B90B", "B", "#1A1400"],
  kraken: ["#5D42D2", "K", "#fff"],
  phantom: ["#AB9FF2", "P", "#1B1436"],
  ledger: ["#111114", "L", "#fff"],
  csv: ["#8A8A8E", "≡", "#fff"],
  kucoin: ["#24AE8F", "K", "#fff"],
  metamask: ["#E2761B", "M", "#fff"],
  bitstamp: ["#149146", "B", "#fff"],
  revolut: ["#0A1B2B", "R", "#fff"],
  eth: ["#627EEA", "Ξ", "#fff"],
  btc: ["#F7931A", "₿", "#fff"],
  sol: ["#1B1436", "◎", "#14F195"],
};

/** The house voice: mono, uppercase, 0.13em. */
export const LAB = "font-mono uppercase tracking-[0.13em]";

/** Money and any figure the eye has to line up down a column. */
export const NUM = "font-mono tabular-nums tracking-[-0.01em]";

export type MsTone = "green" | "tan" | "neg" | "dim" | "mute" | "ink";

export const TONE: Record<MsTone, string> = {
  green: "text-ms-green",
  tan: "text-ms-tan",
  neg: "text-ms-neg",
  dim: "text-ms-dim",
  mute: "text-ms-mute",
  ink: "text-ms-ink",
};
